export {default as general} from './general.tab'
export {default as locations} from './locations.tab'
export {default as reservations} from './reservations.tab'
export {default as employees} from './employees.tab'
export {default as fees} from './fees.tab'
export {default as webhook} from './webhook.tab'
export {default as ancillaries} from './ancillaries.tab'
export {default as apiRateLimit} from './apiRateLimit'
